<script>
    export let content

    import Button from '../common/Button.svelte'

    const title = content.title;
    const text = content.text;
    const items = content.item;
    const anchor = content.anchor;
    const baseURL = 'https://strapi.globalshipping.watch';

    //const textBlocks = JSON.parse(text).blocks
</script>

<!-- Begin of services section -->
<div class="section section-projects section-cent fp-auto-height-responsive anim bg-primary" data-section={anchor}>

    <section class="content clearfix">
      <!-- Begin of Content -->
      <div class="content-centered c-columns">
  
        <div class="wrapper anim">
          <!-- title -->
          <header class="title-desc">
            <span class="anim-wrapper">
                <h2 class="border">{title}</h2>
            </span>
            <span class="anim-wrapper">
                <p>{text}</p>
            </span>
          </header>
  
  
          <!-- Begin of features/services/offers -->
          <ul class="item-list row small-up-1 medium-up-{Math.ceil(items.length / 2)} large-up-{items.length}">
              {#each items as item}
                <!-- item -->
                <li class="column anim">
                    <div class="item-desc">
                      <div class="illustr">
                          {#if item.illustration[0]}
                          <img alt={item.illustration[0].alternativeText} src={`${baseURL}${item.illustration[0].url}`}>
                          {/if}
                      </div>
                      <span class="anim-wrapper">
                          <h3>{item.title}</h3>
                      </span>
                      
                      <div class="desc">
                        {#each JSON.parse(item.text).blocks as block}
                          {#if block.type === 'paragraph'}
                          <span class="anim-wrapper">
                            <p>{ @html block.data.text }</p>
                          </span>
                          {/if}
                        {/each}
                      </div>
                    </div>
                </li>
                <!-- item -->
              {/each}
          </ul>
          <!-- End of features/services/offers -->

          <Button>Read More</Button>
        </div>
      </div>
      <!-- End of Content -->
  
    </section>
  
  </div>
  <!-- End of services section -->  

  <style lang='scss'>
    header {
      margin-bottom: 2rem !important
    }
  </style>